/* Accordion */

jQuery( function($) {
  $( ".c-accordion" ).accordion({
    heightStyle: "content",
    header: '.c-accordion__block > h4',
    collapsible: true,
    active: false,
    animate: 240
  });
});


// Accessible Accordion

// Wait for entire page to load
window.addEventListener('DOMContentLoaded', function () {
  var headers = document.querySelectorAll('.c-ada-accordion .c-ada-accordion--header button');

  // Attach toggle functions to all headers
  headers.forEach(function (header) {
    header.addEventListener('click', function () {
      var currentState = header.getAttribute('aria-expanded');

      // Flip the aria-expanded attribute
      if (currentState === 'true') {
        header.setAttribute('aria-expanded', false);
      } else {
        header.setAttribute('aria-expanded', true);
      }

      // Animate the panel transition between expanded/collapse
      $('#' + header.getAttribute('aria-controls')).slideToggle();
    });
  });
});
